import { render, staticRenderFns } from "./ProgressBenefitModal.vue?vue&type=template&id=a2ce899e&scoped=true"
import script from "./ProgressBenefitModal.vue?vue&type=script&lang=ts"
export * from "./ProgressBenefitModal.vue?vue&type=script&lang=ts"
import style0 from "./ProgressBenefitModal.vue?vue&type=style&index=0&id=a2ce899e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ce899e",
  null
  
)

export default component.exports